import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import useStatsStore from "../../../store/stats.store";
import TableDashBoard from "../../TableDashBoard";

import "../myDashboardPages.scss";
import Filter from "../../filter";
import useSettingstore from "../../../store/settings.store";

export default function MyDashBoardResumeSharing({currentView, cb}) {

  const {myDashConsolidatedStatsResumesShared,getMyDashBoardConsolidatedStatsResumesShared,myDashConsolidatedStatsResumesSharedCount} = useStatsStore();
  const {getMyDashBoardConsolidatedStatsPositiveFeedbacks,myDashConsolidatedStatsPositiveFeedbackCount} = useStatsStore();
  const {getMyDashBoardConsolidatedStatsInterviewScheduling,myDashConsolidatedStatsInterviewSchedulingCount} = useStatsStore();
  const {getMyDashBoardConsolidatedStatsNegativeFeedback,myDashConsolidatedStatsNegativeFeedbackCount} = useStatsStore();
  const {getMyDashBoardConsolidatedStatsSelectionAndOffers,myDashConsolidatedStatsSelectionAndOffersCount} = useStatsStore();
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  

  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();

  useEffect(() => {
    //getAllJds();
  }, []);

  const resumeSharingList = [
    "Sr. No.",
    "Client",
    "TA",
    "Job Title",
    "SPOC",
    "Assigned To",
    "Resumes Shared",
    "Resumes FB Pending",
    "Duplicates",
    "EndClient FB Pending",
  ];


  const resumeDetailData = myDashConsolidatedStatsResumesShared?.resumesharing?.map((resume, idx) => {
    return {
      id: idx + 1 + (pageSize *(currentPage-1)),  
      client_name: resume?.client,
      ta_name: resume?.ta,
      title: '['+resume?.qhcompanyjid+'] '+resume?.title,
      SPOC: resume?.spoc,
      assigned_to: resume?.assignedto,
      shared: resume?.noofresumesshared===0?"-":resume?.noofresumesshared,
      fb_pending: resume?.nooffeedbackpending===0?"-":resume?.nooffeedbackpending,
      duplicates: resume?.noofduplicate===0?"-":resume?.noofduplicate,
      efb_pending: resume?.noofendclientfeedbackpending===0?"-":resume?.noofendclientfeedbackpending,
    };
  });


  return (
    <div className="myDashboard-wrapper">
      <Filter
        filtername = {"getMyDashBoardConsolidatedStats"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}    
        initClient={"All"}           
        enableDuration
        enablePriority
        enableJdStatus
        enableCustomers   
        enableTAs   
        handleFilter={cb}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}  
      />      
      <div></div>

      {myDashConsolidatedStatsResumesShared ? (
        <>
           {currentView==="Resume Sharing"?
             <>
              <TableDashBoard
                isClickable={true}
                isJDPage={true}
                titleList={resumeSharingList}
                data={resumeDetailData}
              />             
             </>:<></>
           }                                       
        </>
        
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={myDashConsolidatedStatsResumesSharedCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />            
    </div>
  );
}
